import { BaSeButton, BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import { AlignButtonsLeft, Container } from './find-manager-by-name-style';

// import { Container } from './styles';

function ConfirmContentIncludeResponsability({
  data,
  confirmInclude,
  closeModal,
}) {
  const { idInterview, idMnagerResponsible } = data;

  return (
    <Container>
      <BaSeParagraph>
        Tem certeza que deseja adicionar um novo Gestor para acompanhar o
        progresso do candidato?
      </BaSeParagraph>

      <BaSeParagraph>
        Ao ser adicionado um novo Gestor, o mesmo também irá receber informações
        via e-mail sobre o processo seletivo do candidato ao Seminário.
      </BaSeParagraph>
      <AlignButtonsLeft>
        <BaSeButton
          value="Sim"
          color={BaSeTheme.colors.defaultColors.black}
          onClick={() =>
            confirmInclude(idInterview, idMnagerResponsible, closeModal)
          }
        />
        <BaSeButton value="Não" type="secondary" onClick={() => closeModal()} />
      </AlignButtonsLeft>
    </Container>
  );
}

export default ConfirmContentIncludeResponsability;
